export default __webpack_public_path__ + "static/media/d-3.2d29935a.png";